const SET_SCREEN_SIZE = 'SET_SCREEN_SIZE'

export const setScreenSize = (payload) => ({
  type: SET_SCREEN_SIZE,
  payload: payload,
})
type ScreenSizeAction = ReturnType<typeof setScreenSize>
type ScreenSizeState = {
  screenSize: string
}
const initialState: ScreenSizeState = {
  screenSize: 'not known',
}
export default function layoutReducer(
  state: ScreenSizeState = initialState,
  action: ScreenSizeAction,
) {
  switch (action.type) {
    case 'SET_SCREEN_SIZE':
      return {
        ...state,
        screenSize: action.payload,
      }

    default:
      return state
  }
}
